<form #ngFormDirtyCheck="ngForm" [formGroup]="priorApprovalsEntryForm">
    <div class="row" *ngIf="enableAgreementYear">
        <div class="col-md-3">
            <kendo-textbox-container floatingLabel="Award Year">
                <kendo-combobox [data]="agreementYearList" title="Award Year"
                    (valueChange)="agreementYearFilterChange($event)">
                </kendo-combobox>
            </kendo-textbox-container>
        </div>
    </div>
    <div class="row"></div>
    <kendo-grid #priorApprovalGrid [data]="priorApprovalsListGrid" [columnMenu]="{sort: true, filter: true, columnChooser: false}"
        [pageSize]="pageSize" [resizable]="true" [skip]="skip" (pageChange)="pageChange($event)"
        (detailExpand)="detailExpanded($event)" (dataStateChange)="dataStateChange($event)"
        (filterChange)="filterChange($event)" [pageable]="{
                buttonCount: buttonCount,
                info: info,
                type: typedg,
                pageSizes: pageSizes,
                previousNext: previousNext
            }" (edit)="editHandler($event)" (cancel)="cancelHandler($event)" filterable="menu" [filter]="filter"
        (save)="saveHandler($event, agreementId, priorApprovalGrid)" (remove)="removeHandler($event, priorApprovalGrid)" (add)="addHandler($event, priorApprovalGrid)">
        <ng-template kendoGridToolbarTemplate>
            <div class="row w-100">
                <div style="text-align:right" class="col-md-3 offset-md-9">
                    <button kendoGridAddCommand [icon]="'add'" [primary]="true"  [disabled]="isReadOnlyPage">Add New Item/Activity</button>
                </div>
            </div>
        </ng-template>
        <kendo-grid-column field="shortDescription" title="item/Action Requiring Approval" [width]="240">
            <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup" let-isNew="isNew">
                <kendo-dropdownlist [data]="priorApprovalsTypeList" [textField]="'shortDescription'"
                    style="min-width: 250px" [valueField]="'priorApporvalTypeId'" [valuePrimitive]="true"
                    [filterable]="true" formControlName="requiringApproval"
                    (filterChange)="handlepriorApprovalsTypeList($event)">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                let-filterService="filterService">
                <kendo-multiselect style="width:220px" [data]="shortDescriptionValue" textField="shortDescription"
                    valueField="shortDescription" [valuePrimitive]="true" [value]="categoryFilters(filter)"
                    (valueChange)="requiringApprovalChange($event, filterService)">
                </kendo-multiselect>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.shortDescription">
                  <span> {{dataItem.shortDescription}}</span>
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Activity/Item Description" field="description" [width]="170">
            <ng-template kendoGridEditTemplate let-dataItem let-isNew="isNew">
                <input kendoTextBox [value]="dataItem.description" formControlName="description">
            </ng-template>
            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                let-filterService="filterService">
                <kendo-multiselect style="width:220px" [data]="itemDescription" textField="description"
                    valueField="description" [valuePrimitive]="true" [value]="categoryFilters(filter)"
                    (valueChange)="descriptionValueChange($event, filterService)">
                </kendo-multiselect>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.description">
                  <span> {{dataItem.description}}</span>
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="agreementYear" title="Award Year" [width]="70">
            <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup" let-isNew="isNew">
                <kendo-dropdownlist formControlName="agreementYearValue" [data]="agreementYearList">
                    <ng-template kendoDropDownListNoDataTemplate>
                        Not a multi-year award
                    </ng-template>
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                <kendo-multiselect style="width:220px" [data]="agreementYearValue" textField="agreementYear" valueField="agreementYear"
                    [valuePrimitive]="true" [value]="categoryFilters(filter)"
                    (valueChange)="agreementYearValueChange($event, filterService)">
                </kendo-multiselect>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.agreementYear">
                  <span> {{dataItem.agreementYear}}</span>
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Other Notes" field="otherNotes" [width]="150">
            <ng-template kendoGridEditTemplate let-dataItem let-isNew="isNew">
                <input kendoTextBox [value]="dataItem.otherNotes" formControlName="otherNotes">
            </ng-template>
            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                let-filterService="filterService">
                <kendo-multiselect style="width:220px" [data]="otherNotesValue" textField="otherNotes"
                    valueField="otherNotes" [valuePrimitive]="true" [value]="categoryFilters(filter)"
                    (valueChange)="otherNotesValueChange($event, filterService)">
                </kendo-multiselect>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.otherNotes">
                  <span> {{dataItem.otherNotes}}</span>
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="value" title="is this item approved in workplan/budget?" [width]="120">
            <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup" let-isNew="isNew">
                <kendo-dropdownlist textField="value" valueField="id" [valuePrimitive]="true" [data]="yesNoList"
                    formControlName="approvedInWorkplan">
                </kendo-dropdownlist>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="requestedDate" title="Date Approval Requested" filter="date" format="{0:dd MMM yyyy}"
            [width]="130">
            <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup" let-isNew="isNew">
                <kendo-textbox-container>
                    <kendo-datepicker [format]="'dd MMM yyyy'" formControlName="requestedDate">
                    </kendo-datepicker>
                </kendo-textbox-container>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.requestedDate">
                    <span>{{dataItem.requestedDate | date:'dd MMM yyyy' }} </span>
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="receivedDate" title="Date Approval/Rejection Received" filter="date"
            format="{0:dd MMM yyyy}" [width]="130">
            <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup" let-isNew="isNew">
                <kendo-textbox-container>
                    <kendo-datepicker [format]="'dd MMM yyyy'" formControlName="receivedDate">
                    </kendo-datepicker>
                </kendo-textbox-container>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.receivedDate">
                    <span>{{dataItem.receivedDate | date:'dd MMM yyyy' }} </span>
                </span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-command-column title="Action" [width]="140">
            <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem let-rowIndex="rowIndex">
                <button [icon]="'edit'" kendoGridEditCommand title="edit" [disabled]="isReadOnlyPage"></button>
                <button [icon]="'delete'" kendoGridRemoveCommand title="delete" [disabled]="isReadOnlyPage"></button>
                <button [icon]="isNew ? 'add' : 'save'" [title]="isNew ? 'add' : 'save'" kendoGridSaveCommand
                    class="priorApprovalSave"></button>
                <button [icon]="'clear'" kendoGridCancelCommand title="clear"></button>
                <button [icon]="'attachment'" kendoButton title="add Document" [disabled]="isNew || disableAddDocButton"
                    (click)="openUploadDocumentDialog(uploadDocumentDialog, dataItem); priorApprovalGrid.expandRow(rowIndex)"></button>
            </ng-template>
        </kendo-grid-command-column>
        <ng-template kendoGridDetailTemplate let-dataItem>
            <div class="data-view-wrapper mt-3">
                <kendo-grid [data]="dataItem.uploadFileList" [columnMenu]="true" filterable="menu" [sortable]="true"
                    [selectable]="true" [resizable]="true">
                    <kendo-grid-column field="Document Name" [style]="{'cursor': 'pointer'}">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span [title]="dataItem.displayFileName">
                                <span class="hyperlink" (click)="enablePreviewDialog(previewDocumentDialog, dataItem)">{{dataItem.displayFileName}}</span>
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="Document Type">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span [title]="dataItem.documentTypeName">
                                <span>{{dataItem.documentTypeName}}</span>
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="Description">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span [title]="dataItem.description">
                                <span>{{dataItem.description}}</span>
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="Attached Date">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span>{{dataItem.createdDate | date}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="Attached By">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span [title]="dataItem.attachedBy">
                                <span>{{dataItem.attachedBy}}</span>
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="Action">
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                            <button type="button" kendoButton [icon]="'edit'" [disabled]="isReadOnlyPage"
                                (click)="editDocument(uploadDocumentDialog,dataItem,rowIndex)"></button>
                            <button type="button" kendoButton [icon]="'delete'" [disabled]="isReadOnlyPage"
                                (click)="deleteDocument(dataItem,rowIndex)"></button>
                            <button type="button" kendoButton [icon]="'download'" title='download'
                                (click)="downloadDocument(dataItem)"></button>
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </ng-template>
    </kendo-grid>
    <button type="submit" id="submitBtn" class="btn btn-success submit_btn d-none"></button>
</form>

<ng-template #uploadDocumentDialog>
    <div [formGroup]="documentFormGroup">
        <div class="row">
            <div class="col-md-12">
                <kendo-textbox-container floatingLabel="Select Document Type" class="required-field">
                    <kendo-dropdownlist class="w-100" [valueField]="'DocumentTypeId'" [textField]="'Description'"
                        formControlName="documentType" [data]="documentTypeList" (valueChange)="documentTypeChange($event)">
                    </kendo-dropdownlist>
                </kendo-textbox-container>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div *ngIf="isDocumentTypeSelected" class="gps-validation-error text-left"><span>Document type
                        required</span></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3">
                <div k-toolbar>
                    <kendo-upload [autoUpload]="false" [restrictions]="uploadRestrictions" [disabled]="!disabledSelectFileButton"
                        (select)="selectEventHandler($event)" [multiple]="false" (clear)="clearEventHandler($event)">
                    </kendo-upload>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div *ngIf="isDocumentSelected" class="gps-validation-error text-left"><span>File required</span></div>
                <div *ngIf="isExistingDocumentName" class="gps-validation-error text-left"><span>Document alredy
                        exist</span></div>
            </div>
        </div>
        <div class="row" *ngIf="isEditDocumentDialug">
            <div class="col-md-10">
                <kendo-textbox-container floatingLabel="Document Name">
                    <input kendoTextBox formControlName="displayFileName">
                </kendo-textbox-container>
            </div>
            <div class="col-md-2 d-table">
                <span class="d-table-cell align-bottom">.{{fileExtension}}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <kendo-textbox-container floatingLabel="Description">
                    <input kendoTextBox value="" style="visibility:hidden; display:none" disabled />
                </kendo-textbox-container>
                <textarea class="w-100 mt-2" kendoTextArea placeholder=""
                    formControlName="documentDescription"></textarea>
            </div>
        </div>
        <div class="row" *ngIf="isExistingDocumentName">
            <div class="col-md-12">
                <fieldset>
                    <legend style="font-size: 18px;">Do you want to override?</legend>
                    <button type="button" class="mt-3" kendoButton [primary]="true"
                        (click)="overrideYes('Yes')">Yes</button>
                    <button type="button" class="mt-3" kendoButton [primary]="true"
                        (click)="overrideYes('No')">No</button>
                </fieldset>
            </div>
        </div>
        <div class="row" *ngIf="!isExistingDocumentName">
            <div class="col-md-12">
                <button type="button" class="pull-right" kendoButton [primary]="true" [icon]="'save'"
                    (click)="addDocument()" [disabled]="!disabledUploadButton"><span>Upload</span></button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewDocumentDialog>
    <div class="row sticky" *ngIf="!isEnablePDF">
        <div class="col-md-12 mt-0 mb-1">
            <button type="button" class="pull-right" kendoButton [primary]="true" [icon]="'download'"
                (click)="downloadDocument(enablePreviewDataItem)" title="Download"></button>
        </div>
    </div>
    <div class="row sticky" *ngIf="isEnablePDF">
        <div class="col-md-12 mt-0 mb-3">
            <button type="button" class="pull-right" kendoButton [primary]="true" [icon]="'download'"
                (click)="downloadDocument(enablePreviewDataItem)" title="Download"></button>
        </div>
    </div>
    <div class="">
        <div class="row" *ngIf="isEnableDOCX">
            <div class="col-md-12">
                <img src="../assets/images/no-preview.png" style="height: calc(100vh - 250px)" />
            </div>
        </div>
        <div class="row" *ngIf="isEnableJPG">
            <div class="col-md-12">
                <img [src]="url" style="height: calc(100vh - 250px)">
            </div>
        </div>
        <div class="row" *ngIf="isEnableTXT">
            <div class="col-md-12">
                <textarea readonly="true" style="width:100%;height: calc(100vh - 250px); background: white; 
            border-width: 1px;" kendoTextArea>{{url}}</textarea>
            </div>
        </div>
        <div class="row" *ngIf="isEnableXLXS">
            <div class="col-md-12 p-0">
                <div style="width: 100%; height: 450px; overflow: auto;">
                    <table id="TheTable" class="ExcelTable" style="width: 100%; height: 450px;">
                        <thead #header>
                            <tr>
                                <th *ngFor="let headValue of headData">
                                    {{headValue}}
                                </th>
                            </tr>
                        </thead>
                        <tbody #container>
                            <tr *ngFor="let row of data">
                                <td *ngFor="let val of headData; let i =index">
                                    {{row[i] || ' '}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="isEnablePDF">
        <pdf-viewer [src]="url" [rotation]="0" [original-size]="false" [show-all]="true" [fit-to-page]="true" [zoom]="1"
            [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true" [external-link-target]="'blank'"
            [autoresize]="false" [show-borders]="false" style="height: 100%; width: 100%; position: absolute;">
        </pdf-viewer>
    </div>
</ng-template>